
export const pmAverage = (params: number[]) => {
  if (!Array.isArray(params)) {
    return 0;
  }
  return params.reduce((acc, value) => acc + (Number.isNaN(Number(value)) ? 0 : Number(value)) , 0) / params.length;
};

export const pmAverageNonZero = (params: number[]) => {
  if (!Array.isArray(params)) {
    return 0;
  }
  const nonZero = params.filter(v => !Number.isNaN(Number(v)) && Number(v) > 0);
  return pmAverage(nonZero);
};

